import React from "react";
import ReactQuill from "react-quill";
import {
  FormGroup,
  Card,
  CardBody,
  Form,
  FormInput,
  FormTextarea,
  Button,
  FormSelect,
  Progress
} from "shards-react";

import "react-quill/dist/quill.snow.css";
import "../../assets/quill.css";

class Editor extends React.Component {
  state = {
    progressBar: 10,
    progressbarcolor : 'primary'
  };

  onPost = async data => {
    var ben = JSON.stringify(data);
    console.log(ben);
    const response = await fetch(`https://expressgenetator.herokuapp.com/users`, {
      method: "POST",
      body: ben,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    });
    if (response.status === 200) {
      // this.componentDidMount()
      console.log("ok");
    } else {
      console.error("this vacation was not added!");
    }
  };

  formHandler = event => {
    const token = sessionStorage.getItem("token");
    const userPicture = sessionStorage.getItem("userimage");
    const userName = sessionStorage.getItem("username");
    const userSurname = sessionStorage.getItem("usersurname");
    const UserID = sessionStorage.getItem("userID");
    
    event.preventDefault();
    let title = event.target.text.value;
    let vacationdescription = event.target.textarea.value;
    let vacationPicture = event.target.url.value;
    let whereVacation = event.target.where.value;
    let newVacation = {
      vacationTitle: title,
      VacationDescription: vacationdescription,
      vacationPicture: vacationPicture,
      vacationProfilepic: userPicture,
      vacationProfileName: userName,
      vacationProfileSurName: userSurname,
      whereVacation: whereVacation,
      token : token, 
      authorid : UserID
    };
    this.onPost(newVacation);
    console.log(newVacation);
  };

  render() {
    return (
      <Card small className="mb-3">
        <Progress theme={this.state.progressbarcolor} value={this.state.progressBar} />
        <CardBody>
          <Form className="add-new-post" onSubmit={this.formHandler.bind(this)}>
            <FormGroup>
              <label htmlFor="#travelStory">Your Ttile</label>
              <FormInput
                size="lg"
                id="#travelStory"
                className="mb-3"
                placeholder="Your Post Travel story"
                name="text"
                onBlur={event => {
                  this.setState({
                    progressBar: this.state.progressBar + 15
                  });
                }}
              />
            </FormGroup>
            <FormGroup>
              <label htmlFor="#TravelBody">Your Travel description</label>
              <FormTextarea
                name="textarea"
                placeholder="Your Post Travel description"
                id="#TravelBody"
                className="mb-8"
                onBlur={event => {
                  this.setState({
                    progressBar: this.state.progressBar + 15
                  });
                }}
              />
            </FormGroup>
            <FormGroup>
              <label htmlFor="#travelStory">Your Travel Picture</label>
              <FormInput
                size="lg"
                id="#travelpic"
                className="mb-3"
                placeholder="Your Post Travel story"
                type="url"
                name="url"
                onBlur={event => {
                  this.setState({
                    progressBar: this.state.progressBar + 15
                  });
                }}
              />
            </FormGroup>
            <label htmlFor="#TravelContinent">Where is it ? </label>
            <FormSelect name="where" size="lg" id="#TravelContinent">
              <option value="Europe">Europe</option>
              <option value="Africa">Africa</option>
              <option value="Middle Est">Middle Est</option>
            </FormSelect>
            <Button
              onClick={event => {
                this.setState({
                  progressBar: this.state.progressBar + 100,
                  progressbarcolor : 'success'
                });
              }}
              type="submit"
              theme="accent"
              size="sm"
              className="ml-auto"
            >
              <i className="material-icons">file_copy</i> Publish
            </Button>
          </Form>
        </CardBody>
      </Card>
    );
  }
}
// <ReactQuill className="add-new-post__editor mb-1" name="textarea2" />

export default Editor;
